__turbopack_context__.v({
  "arc": "loader-module__Qph9mq__arc",
  "arrive": "loader-module__Qph9mq__arrive",
  "loader": "loader-module__Qph9mq__loader",
  "orbit": "loader-module__Qph9mq__orbit",
  "preparing": "loader-module__Qph9mq__preparing",
  "track": "loader-module__Qph9mq__track",
});
